// extracted by mini-css-extract-plugin
export default {"learnMore":"see-more-btn_learnMore__1S-wf"};